import { CommandItem } from '@cobliteam/ui/components/Command';
import { cn } from '@cobliteam/ui/utils';
import { activeBarColor, trackGlobalSearchEvents } from '../helpers';
import { useSearch } from '../hooks/useSearch';
import { type DeviceWithCategory, EnumCategory, type GeofenceWithCategory, type PageWithCategory, type VehicleWithCategory } from '../types';
import DeviceItem from './Details/Device/DeviceItem';
import GeofenceItem from './Details/Geofence/GeofenceItem';
import { PageItem } from './Details/Page/PageItem';
import VehicleItem from './Details/Vehicle/VehicleItem';
import { ItemContent } from './ItemContent';

interface VirtualizedItemProps {
  virtualRow: { index: number; start: number };
}

export const VirtualizedItem = ({ virtualRow }: VirtualizedItemProps) => {
  const { setSelectedItem, resultsByCategory, category, selectedItem } = useSearch();

  const item = resultsByCategory[virtualRow.index];
  const isActive = selectedItem?.id === item.id;

  const handleItemSelect = () => {
    trackGlobalSearchEvents.itemClick(item?.id || '', item.category.id as EnumCategory, item[category.labelKey as keyof typeof item] as string);
    setSelectedItem(item);
  };

  return (
    <CommandItem
      key={virtualRow.index}
      onSelect={handleItemSelect}
      className={cn(
        isActive && 'bg-gray-2 text-gray-12 shadow-none after:bg-primary',
        isActive && activeBarColor(item.category.color),
        '!top-0 !left-0 !w-full !h-50 absolute rounded-none border-gray-4 border-b',
        'after:absolute after:inset-y-0 after:start-0 after:w-[2px]'
      )}
      style={{ transform: `translateY(${virtualRow.start}px)` }}
    >
      {item.category.id === EnumCategory.VEHICLES && <VehicleItem item={item as VehicleWithCategory} />}
      {item.category.id === EnumCategory.DRIVERS && <ItemContent item={item} />}
      {item.category.id === EnumCategory.VEHICLE_GROUPS && <ItemContent item={item} />}
      {item.category.id === EnumCategory.DEVICES && <DeviceItem item={item as DeviceWithCategory} />}
      {item.category.id === EnumCategory.GEOFENCES && <GeofenceItem item={item as GeofenceWithCategory} />}
      {item.category.id === EnumCategory.PAGES && <PageItem item={item as PageWithCategory} />}
      {/* {item.category.id === EnumCategory.IA_ARTICLES && <ArticleIAItem item={item as OramaIaWithCategory} />} */}
      {item.category.id === EnumCategory.ARTICLES && <ItemContent item={item} />}
    </CommandItem>
  );
};
